import type { ResolverTag } from '@ps/web-core-enums';
import { Size } from '@ps/web-core-store';
import classNames from 'clsx';
import React, { useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';
import URL from 'url-parse';

import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import useResolver from '@swf/core/hooks/useResolver';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import styles from './CasinoGameOverlay.scss';

interface LocationStateProps {
  title: string;
  gameUrl: ResolverTag;
  query: object;
}

const CasinoGameOverlay: React.FC<RouteComponentProps<object, object, LocationStateProps>> = (
  props
) => {
  const { title, gameUrl, query } = props.location.state;
  const { setStyle } = useContext(ModalContext);
  const isMobile = useSelector(select.device.isMobile);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { modal } = useDispatch<Dispatch>();

  const resolvedURL = useResolver(gameUrl, {
    query
  });
  const parsedURL = new URL(resolvedURL)
    .set('origin', '')
    .set('hostname', '')
    .set('port', '')
    .set('protocol', '')
    .set('slashes', '');
  const url = parsedURL.toString();

  const closeClick = () =>
    iframeRef?.current?.contentWindow &&
    iframeRef.current.contentWindow.postMessage('starsbeforeclose', window.origin);

  const bindCloseFrame = () => {
    if (iframeRef?.current?.contentWindow) {
      iframeRef.current.contentWindow.close = modal.close;
    }
  };

  useEffect(() => {
    setStyle({
      size: Size.LARGE,
      className: classNames(styles.gameOverlayModal, { [styles.mobile]: isMobile })
    });
  });

  return (
    <Body className={classNames(styles.modalBody)}>
      <CloseButton variant={Variant.Light} onClick={closeClick} />
      <iframe onLoad={bindCloseFrame} title={title} src={url} ref={iframeRef} />
    </Body>
  );
};

export default CasinoGameOverlay;
